import React from "react"
import api from "../../../service/api"
import countdown from "../../../utils/countdown"
import "./index.scss"
import defaultAvatar from "../../../assets/image/ic_default_avatar.png"

const ACTIVITY_HINTS = [
  "你的手速，柔弱中带伤",
  "折扣和好男人，都需要珍惜的",
  "你来迟了我的姐，下次要早哦～"
]

class ArticleHeaderContent extends React.Component {
  state = {
    timer: ACTIVITY_HINTS[0],
  }

  componentDidMount() {
    this.handleTime()
    this.handleRankTime()
  }

  handleRankTime() {
    const _this = this

    let timer = setInterval(function() {
      _this.handleTime(timer)
    }, 1000)
  }

  handleTime(timer = 0) {
    const _this = this
    const { meta, expiration } = _this.props
    if (expiration && expiration.expiresAt) {
      let result = countdown.countdown(expiration.expiresAt)
      if (result === "timeOver") {
        clearInterval(timer)
        let randomIndex = parseInt(Math.random() * 3 + 1, 10) - 1
        _this.setState({
          timer: ACTIVITY_HINTS[randomIndex]
        })
      } else {
        _this.setState({
          timer: result
        })
      }
    }
  }

  handleAvatarError() { 
  }

  render() {
    const { title, text, meta } = this.props

    const { timer } = this.state

    const authorAvatar = meta && meta?.authorAvatar !== '/authors/.png' ? meta.authorAvatar : ""
    const authorLabel = meta ? meta.authorLabel : ""
    return (
      <div className="articleHeaderContentBox">
        <header className="a_h_cb_header">
          <h1>{title || ""}</h1>
        </header>
        <section className="a_h_cb_meta">
          <img
            className="a_h_cb_meta_authAvatar"
            src={api.getResource(authorAvatar) || defaultAvatar}
            onError={this.handleAvatarError}
            alt={`${title} ${authorLabel} user avatar`}
          />
          <span className="a_h_cb_meta_authLabel">{authorLabel} </span>
        </section>
        {this.props.expiration && this.props.expiration.expiresAt && (
          <section className="a_h_cb_meta_rankTime">
            {typeof timer == "object" ? (
              <div>
                <span>活动仅剩: &nbsp;</span>
                <span className="timer_count_down"> {timer.dd}</span>天{" "}
                <span className="timer_count_down"> {timer.hh} </span>时{" "}
                <span className="timer_count_down">{timer.mm}</span>分
              </div>
            ) : (
              <span>{timer}</span>
            )}
          </section>
        )}
        <section className="a_h_cb_text">{text || ""}</section>
      </div>
    )
  }
}

export default ArticleHeaderContent
